<div class="walkthrough-videos">
  <div class="video-icon-wrapper" [ngClass]="{'disabled' : !videoPath}"
    (click)="openModal(videoModal)" role="button" [attr.tabindex]="videoPath ? 0 : -1"
    [attr.aria-disabled]="!videoPath" aria-label="Open walkthrough video"
    (keydown.enter)="videoPath && openModal(videoModal); $event.preventDefault()"
    (keydown.space)="videoPath && openModal(videoModal); $event.preventDefault()">
    <!-- <div class="new-indication" cygovSvgIcon [svgName]="'new-indication-framework'"></div> -->
    <div class="video-icon" [ngClass]="{'disabled' : !videoPath}" cygovSvgIcon
      [svgName]="'video-icon'">
    </div>
  </div>

  <ng-template #videoModal>
    <div class="modal-body">
      <div class="close-icon" cygovSvgIcon [svgName]="'x-icon-type2'" (click)="modalRef.close()"
        role="button" tabindex="0" aria-label="Close walkthrough video"
        (keydown.enter)="modalRef.close(); $event.preventDefault()"
        (keydown.space)="modalRef.close(); $event.preventDefault()">
      </div>
      <div class="video-wrapper section" *ngIf="videoPath">
        <video controls disablePictureInPicture aria-label="Walkthrough video">
          <source [src]="videoPath" type="video/mp4" />
        </video>
      </div>
    </div>
  </ng-template>
</div>
